"use strict";

exports.__esModule = true;
exports.OperatorDeviceSelector = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _OperatorDeviceSelector = require("./OperatorDeviceSelector.legacy");
var _OperatorDeviceSelector2 = require("./OperatorDeviceSelector.modern");
// Flag-gated UI: `OperatorDeviceSelector.legacy` is the component as it is on master,
// `OperatorDeviceSelector.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var OperatorDeviceSelector = exports.OperatorDeviceSelector = (0, _uiSwitch.uiSwitch)(_OperatorDeviceSelector.OperatorDeviceSelector, _OperatorDeviceSelector2.OperatorDeviceSelector, "OperatorDeviceSelector");